import { render, staticRenderFns } from "./SocialUploadStatusAccordion.vue?vue&type=template&id=15f3c36f&scoped=true"
import script from "./SocialUploadStatusAccordion.vue?vue&type=script&lang=js"
export * from "./SocialUploadStatusAccordion.vue?vue&type=script&lang=js"
import style0 from "./SocialUploadStatusAccordion.vue?vue&type=style&index=0&id=15f3c36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3c36f",
  null
  
)

export default component.exports